export default __webpack_public_path__ + "static/media/menu3.b42c3b3a.png";